import { Card, Image } from 'react-bootstrap'
import { CLASSES } from '../../assets/styles/styles'
import { IMAGE_URL } from '../../utils/constants'

function DocumentCard({ document, onClick = () => {} }) {
  return (
    <Card className={CLASSES.content_center}>
      <Image
        src={
          (document?.file_path && document?.file_path.startsWith('http')
            ? document?.file_path
            : IMAGE_URL + document?.file_path) ||
          'https://sertifier.com/blog/wp-content/uploads/2020/10/certificate-text-samples.jpg'
        }
        className='pointer'
        onClick={onClick}
        // onClick={() => handleState(document)}
        style={{
          width: '100%',
          aspectRatio: 1.5 / 1,
          objectFit: 'contain',
        }}
      />
    </Card>
  )
}

export default DocumentCard
